export default __webpack_public_path__ + "static/media/Microsoft Surface Book.dca3e1f3.png";